const tintColor = '#26d07c'
const tintOpposite = '#FF594B'

export default {
  tint: tintColor,
  tintOpposite: tintOpposite,
  tintIconDisabled: '#7C7C7D',
  light: {
    text: '#000000',
    background: '#ffffff',
    tint: tintColor,
    tabIconDefault: '#cccccc',
    tabIconSelected: tintColor,
    listItemBackground: '#E6E6E6',
    listItemDetail: '#2e2e2e',
    placeholderColor: '#6C6C6C',
  },
  dark: {
    text: '#ffffff',
    background: '#000000',
    tint: tintColor,
    tabIconDefault: '#cccccc',
    tabIconSelected: tintColor,
    listItemBackground: '#394A55',
    listItemDetail: '#D4FFFFFF',
    placeholderColor: '#A4A4A4',
  },
}
